export const CHARGING_POINT_QUERY_KEYS = {
  GET_CHARGING_POINT: 'GET_CHARGING_POINT',
} as const
